// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout[data-v-e30a2850]{display:flex;min-height:100vh;flex-direction:column;background-color:#1C0C32;padding-top:88px}@media screen and (max-width: 960px){.layout[data-v-e30a2850]{padding-top:64px}}.layout__main[data-v-e30a2850]{flex:1;display:flex;flex-direction:column}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
